import React from "react";
import { Scissors, Sparkles, Feather, UserRound } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Czyszczenie Instalacji CO",
  description: "Kompleksowe usuwanie zanieczyszczeń i osadów z całego obiegu grzewczego.",
  price: "99% OSADÓW",
  icon: Scissors
}, {
  title: "Płukanie Grzejników",
  description: "Przywracanie pełnej drożności i efektywności oddawania ciepła w Twoim domu.",
  price: "PEŁNA MOC",
  icon: Sparkles
}, {
  title: "Usuwanie Kamienia",
  description: "Profesjonalna eliminacja złogów wapiennych chroniąca kocioł i pompę ciepła.",
  price: "OCHRONA KOTŁA",
  icon: Feather
}, {
  title: "Odmulanie Systemów",
  description: "Mechaniczne usuwanie szlamu i korozji poprawiające przepływ w instalacji.",
  price: "+25% WYDAJNOŚCI",
  icon: UserRound
}];
export default function MenuWybranychUslug() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="32743" id="nasza-oferta-serwisowa" ref={ref} className={cn("bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-700 ease-out")}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-sans font-extrabold tracking-tighter text-primary mb-4 uppercase">
            NASZA OFERTA SERWISOWA
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Czysta instalacja to niższe rachunki za ogrzewanie. Poznaj nasze specjalistyczne usługi dla Twojego domu.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group relative h-full overflow-hidden border-border/50 bg-card transition-all duration-500 hover:border-primary/30 hover:shadow-xl hover:shadow-primary/5 hover:bg-accent">
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-primary/5 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                <CardHeader className="relative z-10 pb-2">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary transition-transform duration-500 group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground">
                    <service.icon className="h-6 w-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-extrabold text-secondary group-hover:text-primary transition-colors duration-300 font-sans tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="relative z-10">
                  <CardDescription className="text-muted-foreground text-base leading-relaxed transition-colors duration-300 group-hover:text-foreground/80 font-sans">
                    {service.description}
                  </CardDescription>
                </CardContent>

                {}
                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full transition-transform duration-500 ease-out group-hover:translate-y-0 bg-gradient-to-t from-background/95 to-transparent !h-[40px]">
                  <div className="flex items-center justify-end">
                    <span className="text-sm font-mono font-semibold text-primary drop-shadow-sm tracking-wider">
                      {service.price}
                    </span>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}